<template>
  <div class="home">
  <van-row class="routerlist box">
      <van-col span="6" class="hrefa">
        <router-link to="/" class="hrefa">
           <i class="iconfont iconshouye"></i>
          <div>首页</div>
        </router-link>
      </van-col>
      <van-col span="6" class="hrefa">
        <router-link to="/course" class="hrefa">
          <i class="iconfont iconkecheng"></i>
          <div>课程</div>
        </router-link>
      </van-col>
      <van-col span="6" class="hrefa">
        <router-link to="/apply" class="hrefa">
         <i class="iconfont iconfaxian"></i>
          <div>应用</div>
        </router-link>
      </van-col>

      <van-col span="6" class="hrefa" @click="gologin">
           <i class="iconfont iconwode"></i>
          <div>我的</div>
      </van-col>
      </van-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { Tabbar, TabbarItem,Col, Row  } from 'vant';

Vue.use(Col);
Vue.use(Row);
Vue.use(Tabbar);
Vue.use(TabbarItem);
export default {
    name: "tabbar",
  data() {
    return {
      currIndex: 0,
      active: 0,
      phone:'',
    }
  },
  mounted(){
    // this.currIndex = this.$route.params.userId
    // console.log(this.$route.params.userId)
    // this.currIndex=2

    this.phone = this.$route.query.mobile

  },
        watch: {
        active(val){
          this.active=val
        }
      },
  methods:{
      onClick() {
        this.active=2
        console.log(this.active)
      },
      gologin(){
        if(localStorage.getItem("userInfo")){
          this.$router.push({path:'/personage'})
        }else{
          // this.$router.push({path:'/login'})
          this.$router.push({
                name:'login',
                query:{
                    mobile: this.phone,
        
                }
            })
        }
      },
    }
}
</script>

<style scoped>
.active_tab img {
  width: 26px;
  height: 26px;
}

.van-tabbar-item--active {
  color: #4e8df6;
}
@media screen and (min-width: 800px) {
  .routerlist{
    width: 800PX;
    position: fixed;
    bottom: 0;
    background: #FFF;
    height: 50px;
    padding-top: 6px;
    z-index: 2;
    padding-bottom: 6px
  }
}
@media screen and (min-width: 320px) and (max-width: 799px) {
  .routerlist{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #FFF;
    height: 50px;
    padding-top: 6px;
    z-index: 2;
    padding-bottom: 6px
  }
}

.hrefa{
  font-size: 14px;
  color: #646566;
  text-align: center;
}
.hrefa .icon{
  font-size: 14px;
  margin-bottom: 5px;
}
.router-link-exact-active{
  color: #1989fa;
}
.iconfont{
  font-size: 0.54rem !important
}

</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue